import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Container, Typography, CircularProgress } from "@mui/material";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import ProductsCollectionItem from "./ProductsCollectionItem";
import "./ProductsCollection.scss";

const ProductsCollection = ({ creator_id }) => {
    const [pageToLoad] = useState(1);
    const [productsCollectionData, setProductsCollectionData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchContent = async () => {
            const prodsQuery = `{
                product_collections(per_page: 12, page : ${pageToLoad}, user_id: ${creator_id}) {
                    total
                    items {
                        title
                        link_url
                        image_url
                        price
                        brand
                    }
                }
            }`;

            axios
                .post(
                    ClientConfigurationHelper.getContentSearchUrl(),
                    { query: prodsQuery },
                    { withCredentials: true }
                )
                .then(({ data: { data: product_collections } }) => {
                    setProductsCollectionData(product_collections);
                })
                .catch((error) => {
                    console.error("Error fetching products collection:", error);
                })
                .finally(() => {
                    setLoading(false);
                });
        };
        fetchContent();
    }, [creator_id, pageToLoad]);

    if (loading) {
        return (
            <Container>
                <CircularProgress />
            </Container>
        );
    }

    if (!productsCollectionData?.product_collections?.items?.length)
        return null;

    return (
        <Container>
            <Box mb={4}>
                <Typography
                    textAlign={{ xs: "center", sm: "start" }}
                    fontSize={{ xs: "20px", sm: "24px" }}
                    fontWeight={700}
                >
                    My Beauty Essentials
                </Typography>
            </Box>
            <Swiper
                modules={[Pagination]}
                slidesPerView={1}
                centerInsufficientSlides={true}
                spaceBetween={16}
                pagination={{ clickable: true }}
                style={{ paddingBottom: "60px", marginBottom: "25px" }}
                breakpoints={{
                    540: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    960: {
                        slidesPerView: 5,
                        spaceBetween: 16,
                    },
                }}
            >
                {productsCollectionData.product_collections.items.map(
                    (item, index) => (
                        <SwiperSlide key={index}>
                            <ProductsCollectionItem
                                item={item}
                                userId={creator_id}
                            />
                        </SwiperSlide>
                    )
                )}
            </Swiper>
        </Container>
    );
};

export default ProductsCollection;
